import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { MethodSection } from '../components/MethodSection';
import { ContentsSection } from '../components/ContentsSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { WhyNowSection } from '../components/WhyNowSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen w-full overflow-x-hidden" data-id="element-215">
      <HeroSection data-id="element-216" />
      <PainSection data-id="element-217" />
      <TruthSection data-id="element-218" />
      <MethodSection data-id="element-219" />
      <ContentsSection data-id="element-220" />
      <ForWhoSection data-id="element-221" />
      <WhyNowSection data-id="element-222" />
      <OfferSection data-id="element-223" />
      <Footer data-id="element-224" />
    </main>;
}